<template>
  <div class="paragraph-logo">
    <ZtLink :to="link?.uri?.path" class="block">
      <img
        v-bind="size"
        :src="imageUrl"
        class="block is-inverted-darkmode max-h-[40px] tablet:max-h-[50px] w-auto dark:invert"
      />
    </ZtLink>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphLogoFragment } from '#graphql-operations'

const props = defineProps<ParagraphLogoFragment>()

defineBlokkli({
  bundle: 'logo',
  globalOptions: ['bkHiddenGlobally'],
})

const imageUrl = computed<string | undefined>(() => {
  return props.logo?.url?.path
})

const size = computed(() => {
  if (props.logo && 'image' in props.logo && props.logo.image) {
    const width = props.logo.image.width
    const height = props.logo.image.height
    if (width && height) {
      return {
        width,
        height,
      }
    }
  }

  return {}
})
</script>

<style lang="postcss">
.paragraph-logo {
  img {
    max-width: 100px;
    max-height: auto;
  }
}
</style>
